import React from "react";
import PropTypes from "prop-types";
import styles from "components/manage-vendors/merge-vendors-modal.scss";
import { selectOptionType } from "custom-prop-types";
import { Modal } from "components/common/modal";
import { Select } from "components/common/select";
import { Button } from "components/common/button";

export const MergeVendorsModal = ({
  accountId,
  isMergeVendorsLoading,
  isMergeVendorsMode,
  onEndMergeVendorsMode,
  onMergeVendors,
  onSelectMergeVendor,
  selectedVendor,
  selectedVendorIds
}) => (
  <Modal
    isVisible={ isMergeVendorsMode }
    onClose={ onEndMergeVendorsMode }
    transitionName={ "merge-vendors" }
  >
    <h2>Merge Vendors</h2>

    <div>Choose which vendor you would to merge the other vendors into:</div>
    <div className={ styles.text }>
      <small>
        (This will retroactively update all documents with the old vendor name(s) to the new vendor name)
      </small>
    </div>
    <Select
      data={ mapVendors(selectedVendorIds) }
      onChange={ (e) => onSelectMergeVendor(e) }
      placeholder="Select a vendor..."
      value={ selectedVendor }
    />
    <div className={ styles.actions }>
      <Button link onClick={ onEndMergeVendorsMode }>cancel</Button>
      <Button
        loading={ isMergeVendorsLoading }
        onClick={ () => onMergeVendors(accountId, selectedVendor, selectedVendorIds) }
        primary
      >
        Merge Vendors
      </Button>
    </div>
  </Modal>
  );

MergeVendorsModal.defaultProps = {
  selectedVendor: null
};

MergeVendorsModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  isMergeVendorsLoading: PropTypes.bool.isRequired,
  isMergeVendorsMode: PropTypes.bool.isRequired,
  onEndMergeVendorsMode: PropTypes.func.isRequired,
  onMergeVendors: PropTypes.func.isRequired,
  onSelectMergeVendor: PropTypes.func.isRequired,
  selectedVendor: selectOptionType,
  selectedVendorIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapVendors = (vendors) => vendors.map((vendor) => ({
  key: vendor,
  name: vendor
}));



// WEBPACK FOOTER //
// ./src/js/components/manage-vendors/merge-vendors-modal.jsx